import React from "react";
import { Form, Input } from "semantic-ui-react";

import { RootState } from "../../store/SrciStore";
import * as action from "../../store/reducers/SrciInputData";
import { useAppSelector, useAppDispatch } from "../../store/hooks";

export default function GeneralInputs() {

  const environments = [
    { key: "QA", text: "QA", value: "QA" },
    { key: "PROD", text: "PROD", value: "PROD" }
  ]

  const generalInput = useAppSelector((state: RootState) => state.srciInputData.generalInput)
  const dispatch = useAppDispatch()

  const handleOnChange = (e: any, element: any) => {
    dispatch(action.save({
      name: element.name,
      value: element.value
    }))
  }

  return (
    <React.Fragment>
      
      <Form>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>Locale</label>
                <Input value={generalInput.locale} name="generalInput.locale" onChange={handleOnChange} />
            </Form.Field>            
            <Form.Field>
                <label>Currency Code</label>
                <Input value={generalInput.currencyCode} name="generalInput.currencyCode" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
                <label>Total Amount</label>
                <Input value={generalInput.totalAmount} name="generalInput.totalAmount" onChange={handleOnChange} />
            </Form.Field>     
            <Form.Field>
                <label>Total Amount Label</label>
                <Input value={generalInput.totalAmountLabel} name="generalInput.totalAmountLabel" onChange={handleOnChange} />
            </Form.Field>                     
        </Form.Group>

        <Form.Group widths='equal'>
            <Form.Field>
                <label>Merchant Name</label>
                <Input value={generalInput.merchantName} name="generalInput.merchantName" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
                <label>Merchant ID</label>
                <Input value={generalInput.merchantId} name="generalInput.merchantId" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
                <label>Payair URL</label>
                <Input value={generalInput.payairUrl} name="generalInput.payairUrl" onChange={handleOnChange} />
            </Form.Field>      
            <Form.Field>
                <label>Transaction ID</label>
                <Input value={generalInput.transactionId} name="generalInput.transactionId" onChange={handleOnChange} />
            </Form.Field>                    
        </Form.Group>  

        <Form.Group widths='equal'>
            <Form.Select fluid label="Environment" name="generalInput.environment" options={environments} defaultValue={generalInput.environment} onChange={handleOnChange} />
            <Form.Field>
                <label>Psp Name</label>
                <Input value={generalInput.pspName} name="generalInput.pspName" onChange={handleOnChange} />
            </Form.Field>
        </Form.Group>                
      </Form>
    </React.Fragment>
  );
}